import { inject } from '@angular/core';
import { NavigationService } from './core/services/navigation.service';
import { MessagesService } from './core/services/messages.service';
import { QuickChatService } from './core/services/quick-chat.service';
import { ShortcutsService } from './core/services/shortcuts.service';
import {forkJoin, take} from 'rxjs';
import {UserService} from "./core/services/user.service";
import {PermissionsService} from "./core/services/permissions.service";
import {CalendarSettingsService} from "./core/services/calendar.settings.service";
import {CalendarWorkingScheduleService} from "./core/services/calendar.working.schedule.service";
import {SterilizationService} from "./features/sterilization/sterilization.service";
import {ClinicInfoService} from "./core/services/clinic.info.service";
import {FeatMgmtService} from "./features/admin/components/feat-mgmt/feat-mgmt.service";
import {AppResourceService} from "./features/admin/components/feat-mgmt/app-resource.service";
import {RecallService} from "./features/recall/recall.service";
import {RecallStatus} from "./features/recall/recall.types";
import {AcademyService} from "./features/academy/academy.service";
import {SMMUserSelectionService} from "./core/services/smm.user.selection.service";


export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    const permissionService = inject(PermissionsService);
    const recallService = inject(RecallService);
    const academyService = inject(AcademyService);

    const userService = inject(UserService);
    const userSelectionService = inject(SMMUserSelectionService);

    const _featMgmtService = inject(FeatMgmtService);
    const _appResourceService = inject(AppResourceService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        forkJoin([
            permissionService.getAllGroups(),
            permissionService.initFeaturesFromToken()
        ]).pipe(take(1)),
        navigationService.get(),
        messagesService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
    ]).pipe(take(1)).subscribe({
        next: (rez) => {},
        complete: () => {
            //initialize user service
            userService.initLoggedInUser();
            userService.getTeam(true);
            _featMgmtService.getModuleInfoFromBE();
            _appResourceService.getResourceInfoFromBE();
            const statuses:RecallStatus[] = [RecallStatus.SCHEDULED, RecallStatus.IN_PROGRESS];
            recallService.getRecallsByStatus(statuses,0,6, "recallDate").subscribe();
            academyService.getCourses().subscribe();

            //update selected user if exists
            let selectedPatientId = localStorage.getItem('selectedPatient');
            let selectedMedicId = localStorage.getItem('selectedMedic');

            if(selectedPatientId){
                userService.getUser(selectedPatientId).pipe(take(1)).subscribe(
                    user => {
                        userSelectionService.updateSelectedUser(user);
                    }
                )
            }
            if(selectedMedicId){
                userService.getUser(selectedMedicId).pipe(take(1)).subscribe(
                    user => {
                        userSelectionService.updateSelectedMedic(user);
                    }
                )
            }
        },
        error: err => { console.error("Error in app resolver: ", err)}
    });
};

export const calendarDataResolver = () => {
    const calendarSettingsService = inject(CalendarSettingsService);
    const calendarWorkingScheduleService = inject(CalendarWorkingScheduleService);
    calendarSettingsService.getSettings();
    calendarWorkingScheduleService.initWorkingHoursDaily();
};

export const sterilizationDataResolver = () => {
    const _sterilizationService = inject(SterilizationService);
    _sterilizationService.getInstrumentsFromBE();
    _sterilizationService.getSterilizationDevicesFromBE();
};

export const financialDataResolver = () => {

    const permissionService = inject(PermissionsService);
    const userService = inject(UserService);
    const clinicInfoService = inject(ClinicInfoService) ;
    clinicInfoService.getClinicInfo(true);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        permissionService.getAllGroups(),
    ]).subscribe({
        next: (rez) => {},
        complete: () => {
            //initialize user service
            userService.initLoggedInUser();
            userService.getTeam(true);
        },
        error: err => { console.error("Error in financial resolver: ", err)}
    });
};




